import { render, staticRenderFns } from "./coderProDxs.vue?vue&type=template&id=3394db64&scoped=true&"
import script from "./coderProDxs.vue?vue&type=script&lang=js&"
export * from "./coderProDxs.vue?vue&type=script&lang=js&"
import style0 from "./coderProDxs.vue?vue&type=style&index=0&id=3394db64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394db64",
  null
  
)

export default component.exports